import { SENDBIRD_INFO } from "../helpers/constant";
import { toastError, toastModal } from "../helpers/methods";

const onMoveToPractice = async (channel, doctorDetails, cb) => {
  try {
    const dataParams = { data: "" };

    const updateResponse = await fetch(
      `https://api-${SENDBIRD_INFO.appId}.sendbird.com/v3/group_channels/${channel.url}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Api-Token": SENDBIRD_INFO.sendBirdToken,
        },
        body: JSON.stringify(dataParams),
      }
    );

    if (!updateResponse.ok) throw new Error("Failed to update channel");

    await fetch(
      `https://api-${SENDBIRD_INFO.appId}.sendbird.com/v3/group_channels/${channel.url}/hide`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Api-Token": SENDBIRD_INFO.sendBirdToken,
        },
        body: JSON.stringify({ should_unhide_all: true }),
      }
    ).
    then(()=> {
    toastModal('Moved to practice Successfully');
    cb(); 
  })
   
  } catch (error) {
    console.error("Error in move to practice:", error);
    toastError("Couldn't Move to Practice");
  }
};


export default onMoveToPractice;
